function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { Conviva } from '@sky-uk-ott/core-video-sdk-js-external-conviva';
import { addMarketUnifiedAdId } from './common-metadata-helper';
var AD_INSIGHTS_EXTENSION = 'Conviva Ad Insights';
var HULU_CCR_EXTENSION = 'hulu_ccr';
export function getExtensionParams(ad, logger, additionalExtensions) {
    var extParams = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var extension = _step.value;
            var _extension_parameters;
            extension === null || extension === void 0 ? void 0 : (_extension_parameters = extension.parameters) === null || _extension_parameters === void 0 ? void 0 : _extension_parameters.forEach(function(param) {
                if (param.name === AD_INSIGHTS_EXTENSION) {
                    try {
                        Object.assign(extParams, _object_spread_props(_object_spread({}, param.value && JSON.parse(decodeURIComponent(param.value))), {
                            marketUnifiedAdID: extension.marketUnifiedAdID
                        }));
                    } catch (e) {
                        logger.warn('Error during parsing of adverts extended Conviva Ad Insights data:' + e);
                    }
                } else if ((additionalExtensions === null || additionalExtensions === void 0 ? void 0 : additionalExtensions.hulu) && param.name === HULU_CCR_EXTENSION && param.value) {
                    try {
                        var huluCcr = decodeURIComponent(param.value);
                        var huluObj = {};
                        huluCcr.split(';').forEach(function(keyValuePair) {
                            var _keyValuePair_split = _sliced_to_array(keyValuePair.split('='), 2), key = _keyValuePair_split[0], value = _keyValuePair_split[1];
                            huluObj[key] = value;
                        });
                        Object.assign(extParams, {
                            hulu: huluObj
                        });
                    } catch (e) {
                        logger.warn('Error during parsing of adverts extended Hulu CCR data:' + e);
                    }
                }
            });
        };
        for(var _iterator = addMarketUnifiedAdId(replaceApiFramework(ad))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return extParams;
}
export function mapAdPosition(adPosition) {
    switch(adPosition){
        case 'preroll':
            return Conviva.Constants.AdPosition.PREROLL;
        case 'midroll':
        case 'overlay':
            return Conviva.Constants.AdPosition.MIDROLL;
        case 'postroll':
            return Conviva.Constants.AdPosition.POSTROLL;
    }
}
function replaceApiFramework(ad) {
    var _ad_features;
    if ((_ad_features = ad.features) === null || _ad_features === void 0 ? void 0 : _ad_features.isBrightlineAd) {
        var _ad_extensions;
        (_ad_extensions = ad.extensions) === null || _ad_extensions === void 0 ? void 0 : _ad_extensions.forEach(function(ext) {
            ext.parameters.forEach(function(param) {
                if (param.name === AD_INSIGHTS_EXTENSION) {
                    var _param_value;
                    param.value = (_param_value = param.value) === null || _param_value === void 0 ? void 0 : _param_value.replace(/"mediaFileApiFramework": "[^"]*"/, '"mediaFileApiFramework": "brightline"');
                }
            });
        });
    }
    return ad.extensions || [];
}

//# sourceMappingURL=metadata-ad-helper.js.map